import React from "react";
import times from "lodash/times";
import DPTable, { Header } from "Components/DP/DPTable/DPTable";
import { DPComponentLoader, DPEmptyTable } from "Components/DP";
import { useRewards } from "../useRewards";
import { RewardsTableRow } from "./RewardsTableRow/RewardsTableRow";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { RewardsStatusHeadCell } from "./RewardsStatusHeadCell/RewardsStatusHeadCell";

const headers = [
  "Date/Time",
  "Rewarded by",
  "Amount",
  "Rewarded to",
  "Location",
  "User ID",
  "Comment",
  "Date Sent to User",
  "Date Claimed by User",
  <RewardsStatusHeadCell />,
  { label: "Action", align: "center" },
] as Header[];

export const RewardsTable = () => {
  const evenColWidths = times(headers.length, () => 100 / headers.length);
  const { rewards, loading, page, rowsPerPage, onChangePage } = useRewards();
  const { employer } = usePartnerConfig();

  return (
    <DPTable
      count={rewards?.totalCount}
      headers={headers}
      page={page}
      rowsPerPage={rowsPerPage}
      colWidths={evenColWidths}
      onChangePage={onChangePage}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          rewards?.items.length ? (
            <>
              {rewards.items.map(reward => (
                <RewardsTableRow
                  key={reward.id}
                  reward={reward}
                  employerId={employer.id}
                />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Rewards will appear here"} />
          )
        }
      />
    </DPTable>
  );
};
